var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReason2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1116.082 2272.045 84.564 93.842",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Urban_Renewal_Tool_-_Homepage_1366px_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4535
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Urban_Renewal_Tool_-_Homepage_1366px_",
    "data-name": "Urban Renewal Tool - Homepage 1366px ",
    className: "cls-3",
    style: {
      clipPath: "url(#clip-Urban_Renewal_Tool_-_Homepage_1366px_)"
    },
    transform: "matrix(1, 0, 0, 1, 67.621826, -1705.269897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hp_impact_renewal_icon4",
    "data-name": "hp_impact renewal_icon4",
    transform: "matrix(1, 0, 0, 1, 1501.016479, 3543.405273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    className: "cls-1022",
    d: "M6487.718,7265.919h12.7l-3.178,6.354,3.178,6.354H6487.7v-3.177",
    transform: "translate(-6432.413 -7262.742)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    className: "cls-1022",
    d: "M6471.434,7262.3h14.3v12.709h-14.3",
    transform: "translate(-6430.751 -7262.304)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(0 1.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    className: "cls-1014",
    d: "M6437.537,7310.06l-8.366-5.976a3.6,3.6,0,0,1-.96-4.837l2.46-3.936a12.555,12.555,0,0,1,10.65-5.9h24.812s.364,5.394-4.765,6.354c-3.1.58-11.121,1.588-11.121,1.588v7.94l7.943,11.116v11.128",
    transform: "translate(-6426.417 -7266.253)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    className: "cls-1014",
    d: "M6446.131,7338.766l1.588-22.241,6.355,6.354v7.943",
    transform: "translate(-6428.264 -7269.019)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    className: "cls-1014",
    d: "M6426.245,7345.5l8.117-3.177h6.966l2.773-1.589h4.87l3.247-7.943h6.493l4.87,3.177h6.493l3.247,3.177h6.493l6.493,6.354",
    transform: "translate(-6426.245 -7270.991)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    className: "cls-1014",
    d: "M6435.284,7301.844l3.177-1.59v38.128",
    transform: "translate(-6427.34 -7267.046)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    className: "cls-1014",
    y2: 36.538,
    transform: "translate(38.878 28.442)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    className: "cls-1014",
    y2: 22.241,
    transform: "translate(38.878)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    className: "cls-1035",
    d: "M6446.233,7282.491a5.653,5.653,0,0,0,5.812-5.979v-2.989a5.815,5.815,0,1,0-11.625,0v2.989A5.653,5.653,0,0,0,6446.233,7282.491Z",
    transform: "translate(-6427.665 -7264.516)",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    className: "cls-1014",
    d: "M6489.08,7269.521h9.532l-3.177,6.354,3.177,6.354H6485.9v-3.177",
    transform: "translate(-6432.195 -7264.756)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    className: "cls-1014",
    d: "M6469.632,7265.906h14.3v12.709h-14.3",
    transform: "translate(-6430.543 -7264.317)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "hp_impact_renewal_icon3",
    "data-name": "hp_impact renewal_icon3",
    transform: "matrix(1, 0, 0, 1, 1384.234253, 3528.471924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    className: "cls-1037",
    d: "M6469.892,7131.747h7.117l2.847-5.694h7.117l5.694-14.234h4.271",
    transform: "translate(-6435.208 -7103.57)",
    style: {
      fill: "none",
      stroke: "rgb(215, 220, 228)",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    className: "cls-1014",
    d: "M6453.59,7170.6v-40.039h7.813c4.716,0,6.251-2.852,6.251-6.405h-28.13c-2.93,0-7.813,2.421-7.813,9.609v11.211a6.464,6.464,0,0,0,6.25,6.406",
    transform: "translate(-6431.712 -7105.065)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    className: "cls-1014",
    y2: 35.943,
    transform: "translate(6.251 28.785)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    className: "cls-1014",
    width: 12.147,
    height: 14.946,
    rx: 6.074,
    transform: "translate(7.814)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    className: "cls-1014",
    y2: 23.441,
    transform: "translate(14.064 41.287)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    transform: "translate(28.991 0.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    className: "cls-1014",
    d: "M6463.413,7116.839V7102.6h37.009v39.856h-37.009V7132.5",
    transform: "translate(-6463.413 -7102.604)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    className: "cls-1014",
    d: "M6469.892,7136.491h7.117l2.847-5.693h7.117l5.694-14.234h4.271",
    transform: "translate(-6464.199 -7104.297)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hp_impact_renewal_icon2",
    "data-name": "hp_impact renewal_icon2",
    transform: "matrix(1, 0, 0, 1, 1057.102417, 3989.924316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    className: "cls-1022",
    d: "M6467.063,6979.827l1.981-4.055a1.383,1.383,0,0,0-1.216-2h-10.55a1.355,1.355,0,0,0-1.215.766l-6.795,13.832a1.383,1.383,0,0,0,1.215,2h10.55a1.356,1.356,0,0,0,1.215-.764l1.844-3.754",
    transform: "translate(-6434.859 -6944.168)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    className: "cls-1014",
    d: "M6446.578,6956.6a6.173,6.173,0,0,0,6.025-6.455v-2.153a6.039,6.039,0,1,0-12.05,0v2.153A6.173,6.173,0,0,0,6446.578,6956.6Z",
    transform: "translate(-6434.528 -6941.538)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    className: "cls-1014",
    d: "M6445.75,6984.2l-5.086-1.035c-1.432-.2-2.4-.522-3.741-2.542l-1.285-2.836c-1.134-2.492-1.941-3.561-1.941-5.59,0-4.246,2.17-8.379,6.956-8.379h8.682c2.783.113,4.491.6,6.011,2.432s2.945,3.561,2.945,3.561",
    transform: "translate(-6433.697 -6943.282)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    className: "cls-1014",
    d: "M6441.816,6972.877l1.361,3.4a3.618,3.618,0,0,0,2.469,2.36l3.506,1.246",
    transform: "translate(-6434.681 -6944.302)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    className: "cls-1035",
    d: "M6464.744,6983.556h-5.318c-.289-3.577,2.826-6.024,2.826-6.024h4.778a1.5,1.5,0,0,1,1.264,2.179l-1.023,2.179A2.811,2.811,0,0,1,6464.744,6983.556Z",
    transform: "translate(-6436.814 -6944.732)",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    className: "cls-1014",
    d: "M6464.8,6976.7l1.981-4.055a1.382,1.382,0,0,0-1.215-2h-10.549a1.359,1.359,0,0,0-1.217.764L6447,6985.237a1.382,1.382,0,0,0,1.215,2h10.551a1.356,1.356,0,0,0,1.215-.764l1.844-3.754",
    transform: "translate(-6435.293 -6943.913)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319",
    "data-name": "Line 319",
    className: "cls-1014",
    y2: 26.021,
    transform: "translate(6.025 40.916)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    className: "cls-1014",
    y2: 16.568,
    transform: "translate(13.556 50.369)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    className: "cls-1014",
    y2: 22.593,
    transform: "translate(21.087 44.345)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    transform: "translate(39.22 2.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    className: "cls-1014",
    d: "M6493.521,6979.442v7.223h-17.335v-15.891",
    transform: "translate(-6476.187 -6946.574)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    className: "cls-1014",
    d: "M6493.521,6953.139v7.223h-17.335v-15.891",
    transform: "translate(-6476.187 -6944.471)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    className: "cls-1014",
    d: "M6493.521,6979.442v7.223h-17.335v-15.891h13",
    transform: "translate(-6476.187 -6946.574)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    className: "cls-1014",
    d: "M6481.118,6978l4.333,4.334,10.113-11.557",
    transform: "translate(-6476.785 -6946.667)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    className: "cls-1014",
    d: "M6493.521,6997.523v15.445h-17.335v-15.891h17.335",
    transform: "translate(-6476.187 -6948.677)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    className: "cls-1014",
    d: "M6493.521,6953.139v7.223h-17.335v-15.891h13",
    transform: "translate(-6476.187 -6944.471)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    className: "cls-1014",
    d: "M6481.118,6951.694l4.333,4.334,10.113-11.557",
    transform: "translate(-6476.785 -6944.471)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    className: "cls-1014",
    x1: 7.528,
    y2: 7.367,
    transform: "translate(4.904 52.755)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    className: "cls-1014",
    x2: 7.588,
    y2: 7.293,
    transform: "translate(4.874 52.792)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason2);
export default __webpack_public_path__ + "static/media/reason2.1fb241b2ed9bd4f0e9915aefc7801136.svg";
export { ForwardRef as ReactComponent };